const STORAGE_PREFIX = 'advicelink_sidebar_group_visibility';

function storageKey(userEmail) {
  const email = (userEmail || '').trim().toLowerCase();
  return email ? `${STORAGE_PREFIX}:${email}` : STORAGE_PREFIX;
}

/** Current schema of the stored eye-toggle map (group names; v3 = Oversight → Reports, Oct 2026). */
const SCHEMA_VERSION = 3;

/**
 * Stored prefs are keyed by group label. Older maps (no `__v`) used
 * Tools/Compliance (v0), Dashboard/Advice/Analysis/Records/Reporting (v1) and
 * Oversight (v2);
 * carry each choice to the group that replaced it. Versioned because "Tools"
 * is a current group name again.
 */
function migrateLegacyGroupKeys(visibility) {
  if (!visibility || typeof visibility !== 'object') return {};
  if (visibility.__v === SCHEMA_VERSION) return visibility;
  if (visibility.__v === 2) {
    const next = { ...visibility, __v: SCHEMA_VERSION };
    if ('Oversight' in next) {
      if (!('Reports' in next)) next.Reports = next.Oversight;
      delete next.Oversight;
    }
    return next;
  }
  const old = { ...visibility };
  if ('Tools' in old && !('Advice' in old)) old.Advice = old.Tools;
  if ('Compliance' in old && !('Records' in old)) old.Records = old.Compliance;
  const next = { __v: SCHEMA_VERSION };
  const carry = (from, to) => { if (from in old && !(to in next)) next[to] = old[from]; };
  carry('Dashboard', 'Workspace');
  carry('Advice', 'Client');
  carry('Analysis', 'Tools');
  carry('Reporting', 'Reports');
  carry('Support', 'Support');
  carry('Roles', 'Roles');
  return next;
}

export function loadSidebarGroupVisibility(userEmail) {
  try {
    const raw = localStorage.getItem(storageKey(userEmail));
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') return migrateLegacyGroupKeys(parsed);
    }
  } catch {
    // ignore corrupt storage
  }
  return {};
}

export function saveSidebarGroupVisibility(userEmail, visibility) {
  try {
    localStorage.setItem(storageKey(userEmail), JSON.stringify({ ...visibility, __v: SCHEMA_VERSION }));
  } catch {
    // ignore quota / private mode
  }
}

/** @returns {boolean} true when group pages should show (default visible) */
export function isSidebarGroupExpanded(visibility, groupKey) {
  if (!groupKey) return true;
  if (visibility[groupKey] === false) return false;
  return true;
}
